import React from 'react';
import { connect } from 'react-redux';
// import { hot } from 'react-hot-loader/root'
import { AppState } from 'core/redux/reducers';
import { IBox, makeSelectBox } from 'core/redux/features/boxes/box';

interface AppPropTypes {
  code: string;
  box?: IBox | null;
  className?: string;
}

class BoxComponent extends React.Component<AppPropTypes> {
  static defaultProps = {
    className: '',
  };

  render() {
    const { box, className } = this.props;
    if (!box) {
      return null;
    }

    return (
      <div
        className={className}
        dangerouslySetInnerHTML={{ __html: box.content }}
      />
    );
  }
}

const mapStateToProps = (state: AppState, ownProps: AppPropTypes) => {
  return {
    box: makeSelectBox()(state, ownProps.code),
  };
};

const mapDispatchToProps = {};

// const BoxRoot = process.env.NODE_ENV !== 'production' ? hot(BoxComponent) : BoxComponent;
const Box = connect(mapStateToProps, mapDispatchToProps)(BoxComponent);
export default Box;
